import { Nullable } from '../../../types/types';
import { IOfferLetter } from 'modules/offerLetter/store/model';
import { formatShortDate } from 'shared/utils/formatters/dateFormatter';

export function getFormattedOfferLetterStartDate(offerLetter: Nullable<IOfferLetter>): string {
    return offerLetter?.start_date ? formatShortDate(offerLetter.start_date) : '';
}
